import { useErrorBoundary } from "component-library";
import { usePublicView } from "pages/Profile/hooks/usePublicView";
import { useGetPublicProfile } from "pages/Profile/hooks/useGetPublicProfile";
import { useQuery } from "react-query";
import { IAgency } from "models";
import { AxiosError } from "axios";
import { authAxios as axios } from "api-generate-types/src/axios";
import { getLiteAgentApiUrl } from "services/UrlBuilder";
import { HALManager, UserManager } from "core";

const GET_REPS_QUERY_KEY = "GET_REPS_QUERY_KEY";

export default function useGetReps() {
  const captureError = useErrorBoundary();
  const { isPublicView } = usePublicView();
  const { data: publicProfileData, isLoading: isPublicProfileLoading } =
    useGetPublicProfile();

  const { data: repsData, isLoading: repsDataIsLoading } = useQuery<
    {
      agents: IAgency[];
      schools: IAgency[];
      isSelfRepresented: boolean;
      isLookingForRepresentation: boolean;
    },
    AxiosError
  >(
    GET_REPS_QUERY_KEY,
    async () => {
      const { data } = await axios.get(
        getLiteAgentApiUrl(HALManager.addAgencyUrl(UserManager.artistRef ?? ""))
      );

      return data;
    },
    {
      enabled: !isPublicView,
      cacheTime: 0,
      onError: captureError,
    }
  );

  const isLoading = isPublicProfileLoading || repsDataIsLoading;

  const agents = isPublicView ? publicProfileData?.agents : repsData?.agents;
  const schools = isPublicView ? publicProfileData?.schools : repsData?.schools;
  const isSelfRepresented = isPublicView
    ? publicProfileData?.isSelfRepresented
    : repsData?.isSelfRepresented;
  const isLookingForRepresentation = isPublicView
    ? publicProfileData?.isLookingForRepresentation
    : repsData?.isLookingForRepresentation;

  return {
    isSelfRepresented,
    isLookingForRepresentation,
    agents,
    schools,
    isLoading,
  };
}
